import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 20%;
  padding: 30px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalFooter = styled.div`
  margin-top: 20px;
`;

export const ModalBody = styled.div``;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.93);
  margin: 10px 0px;
`;

export const SubTitle = styled.div`
  font-weight: 500;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.93);
  margin: 10px 0px;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;

export const SelectedAddress = styled.div`
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  font-size: 1rem;
`;

export const ShippingAddress = styled.div`
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const BillingAddress = styled.div`
  margin-top: 30px;
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
export const AddressWrapper = styled.div``;

export const MailingName = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
`;

export const Address = styled.div`
  font-size: 1rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 5px;
`;

export const SelectedAddressContainer = styled.div`
  min-width: 33.3%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    & + & {
      padding: 2rem 0 0 0;
    }
  }
`;

export const AddressContainer = styled.div<{ isSelected: boolean }>`
  padding: 10px;
  border-radius: 5px;
  border: ${({ isSelected }) =>
    isSelected
      ? '2px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};

  width: 100%;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 45%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
